(() => {
  if (window.NSProductStory) return;
  const initialized = new WeakSet();
  const initCarousel = (root) => {
    if (initialized.has(root)) return;
    initialized.add(root);
    const track = root.querySelector('[data-ns-carousel-track]');
    const controls = root.querySelector('[data-ns-carousel-controls]');
    const previous = root.querySelector('[data-ns-carousel-prev]');
    const next = root.querySelector('[data-ns-carousel-next]');
    const status = root.querySelector('[data-ns-carousel-status]');
    if (!track || !controls || !previous || !next || !status) return;
    const cards = [...track.children];
    const update = () => {
      const limit = track.scrollWidth - track.clientWidth;
      controls.hidden = limit <= 2;
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= limit - 2;
      const left = track.getBoundingClientRect().left;
      const index = cards.reduce((closest, card, n) => Math.abs(card.getBoundingClientRect().left - left) < Math.abs(cards[closest].getBoundingClientRect().left - left) ? n : closest, 0);
      status.textContent = `${index + 1} / ${cards.length}`;
    };
    const move = (direction) => {
      const step = (cards[0]?.getBoundingClientRect().width || track.clientWidth) + 16;
      track.scrollBy({ left: direction * step, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    };
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', update, { passive: true });
    new ResizeObserver(update).observe(track);
    update();
  };
  const init = (scope = document) => scope.querySelectorAll('[data-ns-carousel]').forEach(initCarousel);
  window.NSProductStory = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
